import { getBuyersFilterApi } from "api/common";
import { FC, useState } from "react";
import CustomButton from "ui/Button";
import CustomDropDownList from "ui/dropDown";
import { DATE_FORMAT, ICON_NAMES } from "utils/constant";
import { useTranslation } from "react-i18next";
import { PickListFilter } from "api/pickList";
import { Buyer } from "interface/buyer";
import DatePickerComponent from "ui/Date";

interface CustomProps {
	pageSize: number;
	setFilterOptions: (options: PickListFilter) => void;
	filterOptions: PickListFilter;
	exportAsPDF: () => void;
	exportAsExcel: () => void;
}
const Filter: FC<CustomProps> = ({
	setFilterOptions,
	filterOptions,
	exportAsPDF,
	...props
}) => {
	const { t } = useTranslation();
	const [tempFilter, setTempFilter] = useState<Partial<PickListFilter>>({});

	const applyFromDate = () => {
		const newValue = tempFilter.fromDate;
		if (newValue === undefined || newValue === filterOptions.fromDate) return;
		setFilterOptions({
			...filterOptions,
			fromDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	const applyToDate = () => {
		const newValue = tempFilter.toDate;
		if (newValue === undefined || newValue === filterOptions.toDate) return;
		setFilterOptions({
			...filterOptions,
			toDate: newValue,
			take: props.pageSize,
			skip: 0,
		});
	};

	return (
		<div className="filter-container">
			<div className="filter-items">
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("FromDate")}
						label={t("FromDate")}
						className="height-inherit"
						format={DATE_FORMAT}
						value={tempFilter.fromDate !== undefined ? tempFilter.fromDate : filterOptions.fromDate}
						onChange={(e) =>
							setTempFilter({ ...tempFilter, fromDate: e.target.value })
						}
						onBlur={() => applyFromDate()}
					/>
				</div>
				<div style={{ width: "170px" }}>
					<DatePickerComponent
						placeholder={t("ToDate")}
						label={t("ToDate")}
						className="height-inherit"
						format={DATE_FORMAT}
						value={tempFilter.toDate !== undefined ? tempFilter.toDate : filterOptions.toDate}
						onChange={(e) =>
							setTempFilter({ ...tempFilter, toDate: e.target.value })
						}
						onBlur={() => applyToDate()}
					/>
				</div>

				<div style={{ width: "170px" }}>
					<CustomDropDownList
						onSelect={(buyer: Buyer) =>
							setFilterOptions({
								...filterOptions,
								buyerId: buyer.id as any,
								buyerName: buyer.name,
								buyerLedgerNumber: buyer.id as any,
								take: props.pageSize,
								skip: 0,
							})
						}
						data={[]}
						value={{
							id: filterOptions.buyerId || null,
							displayName: filterOptions.buyerName || ' '
						}}
						dataItemKey="id"
						textField="displayName"
						label={t("Buyer")}
						defaultItem={{ id: null, displayName: t("All") }}
						className="height-inherit"
						filterable={true}
						serverFilter={true}
						serverFilterApi={getBuyersFilterApi}
					/>
				</div>
			</div>

			<div className="filter-end-btn">
				<CustomButton
					label={"PDF"}
					onClick={() => exportAsPDF()}
					iconName={ICON_NAMES.Download}
				/>
				<CustomButton
					label={"Excel"}
					onClick={() => props.exportAsExcel()}
					iconName={ICON_NAMES.Download}
				/>
			</div>
		</div>
	);
};

export default Filter;
